import { render, staticRenderFns } from "./MergeAccountsModal.vue?vue&type=template&id=8e4fd16a&"
import script from "./MergeAccountsModal.vue?vue&type=script&lang=ts&"
export * from "./MergeAccountsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports